import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';

import moment from 'moment';

import TotalModalWrapper from '../../../Share/Normal/TotalModalWrapper';
import WhiteTrashIcon from '../../../../image/WhiteTrashIcon.png';
import ExitButtonIcon from '../../../../image/ExitButtonImage.svg';

export default function NewClassDeleteModal(props) {
  const { deletedData, onClickExit, onClickOnlyOneDelete, onClickAllDelete } = props;
  const { t } = useLanguage();

  const [title, setTitle] = useState('');

  // 삭제 텍스트 정리 //
  useEffect(() => {
    if (deletedData === undefined || title !== '') return;

    let dateText = moment(deletedData.classDate, 'YYYY.MM.DD').format(t('classManage.dateFormatShortDay'));
    let className = deletedData.className;

    if (className.length > 14) className = className.slice(0, 14) + '...';

    setTitle(t('classManage.deleteClassTitle', { date: dateText, className }));
  }, [deletedData, title])

  // 지정일 버튼에 마우스 호버링 시작 //
  function onMouseEnterOnlyOneButton() {
    let dateText = moment(deletedData.classDate, 'YYYY.MM.DD').format(t('classManage.dateFormatShortDay'));
    let className = deletedData.className;

    if (className.length > 10) className = className.slice(0, 10) + '...';

    setTitle(t('classManage.deleteOnlyOneClass', { date: dateText, className }));
  }

  // 지정일 버튼에 마우스 호버링 끝 //
  function onMouseLeaveOnlyOneButton() {
    let dateText = moment(deletedData.classDate, 'YYYY.MM.DD').format(t('classManage.dateFormatShortDay'));
    let className = deletedData.className;

    if (className.length > 14) className = className.slice(0, 10) + '...';

    setTitle(t('classManage.deleteClassTitle', { date: dateText, className }));
  }

  // 영구삭제 버튼에 마우스 호버링 시작 //
  function onMouseEnterAllButton() {
    let dateText = moment(deletedData.classDate, 'YYYY.MM.DD').format(t('classManage.dateFormatShortDay'));
    let className = deletedData.className;

    if (className.length > 10) className = className.slice(0, 10) + '...';

    setTitle(t('classManage.deleteAllFromDate', { date: dateText, className }));
  }

  // 영구삭제 버튼에 마우스 호버링 끝 //
  function onMouseLeaveAllButton() {
    let dateText = moment(deletedData.classDate, 'YYYY.MM.DD').format(t('classManage.dateFormatShortDay'));
    let className = deletedData.className;

    if (className.length > 14) className = className.slice(0, 10) + '...';

    setTitle(t('classManage.deleteClassTitle', { date: dateText, className }));
  }

  return (
    <TotalModalWrapper>
      <ModalView>
        <RedTrashBoxWrapper>
          <EmptyButtonWrapper/>
          <RedTrashBox>
            <TrashImage src={WhiteTrashIcon} />
          </RedTrashBox>
          <ExitButtonWrapper
            onTouchEnd={(e) => { e.preventDefault(); onClickExit(); }}
            onClick={onClickExit}>
            <ExitImage src={ExitButtonIcon} />
          </ExitButtonWrapper>
        </RedTrashBoxWrapper>
        <TotalWrapper>
          <Title>{title}</Title>
          <TextWrapper>
            <Explanation>{t('classManage.deleteWarning1')}</Explanation>
            <Explanation>{t('classManage.deleteWarning2')}</Explanation>
          </TextWrapper>
        </TotalWrapper>
        <ButtonWrapper>
          <OnlyOneDeleteButton
            onMouseEnter={onMouseEnterOnlyOneButton}
            onMouseLeave={onMouseLeaveOnlyOneButton}
            onTouchEnd={(e) => { e.preventDefault(); onClickOnlyOneDelete(); }}
            onClick={onClickOnlyOneDelete}>
            {t('classManage.thisDate')}
          </OnlyOneDeleteButton>
          <AllDeletetButton
            onMouseEnter={onMouseEnterAllButton}
            onMouseLeave={onMouseLeaveAllButton}
            onTouchEnd={(e) => { e.preventDefault(); onClickAllDelete(); }}
            onClick={onClickAllDelete}>
            {t('classManage.deleteAllWeeks')}
          </AllDeletetButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  margin: 0 0 0 0;

  text-align: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  margin-top: 8px;
  
  // gap: 4px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #595959;
  
  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const RedTrashBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF3131;
`;

const TrashImage = styled.img`
  width: 53px;
  height: 53px;
`;

const EmptyButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
`;

const ExitButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 36px;

  width: 12px;
  height: 12px;

  &:hover {
    cursor: pointer;
  }
`;

const ExitImage = styled.img`
  width: 12px;
  height: 12px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const OnlyOneDeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: #CFCFCF;
  
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #6DD49E;
  }
`;

const AllDeletetButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: #CFCFCF;
  
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF3131;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: #FF3131;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;